import { render } from "./AWRegularContributionChart.vue?vue&type=template&id=5c2b49ee"
import script from "./AWRegularContributionChart.vue?vue&type=script&lang=js"
export * from "./AWRegularContributionChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__